import React from 'react';
import type { PlaceTranslation, AssetRef } from '../../types/place';
import TextWidget from './TextWidget';
import AudioWidget from './AudioWidget';
import VideoWidget from './VideoWidget';
import ChatWidget from './ChatWidget';
import AudioDescriptionWidget from './AudioDescriptionWidget'
import DeafVideoWidget from './DeafVideoWidget';

interface WidgetManagerProps {
    widget: string;
    translations: PlaceTranslation;
    currentAsset: string;
    stationName?: string;
}

const WidgetManager: React.FC<WidgetManagerProps> = ({ widget, translations, currentAsset, stationName }) => {
    switch (widget) {
        case 'text':
            return <TextWidget text={translations?.information_description} />;
        case 'audio':
            return <AudioWidget audio={translations.audio} name={stationName} />;
        case 'video':
            return <VideoWidget videoInfo={translations.video} name={stationName} />
        case 'chat':
            return <ChatWidget  />;
        case 'audio-description':
            return <AudioDescriptionWidget audio={translations.accessibility_vision_audio_description as AssetRef | null}/>
        case 'accessible-video':
            return <DeafVideoWidget video={translations[currentAsset] as AssetRef | null}/> 
        default:
            return <div>Select a widget to display content</div>;
    }
};

export default WidgetManager;
